export const CONFIG_TYPES = {
  DEDUPLICATION: 'deduplication',
  FIELD_MAPPING: 'fieldMapping',
  TICKET_FIELD_MAPPING: 'ticketFieldMapping',
};

// check this constant need or not
export const VELARIS_TICKET_STATUS = {
  new: { id: 'new', name: 'New', isRequired: false },
  open: { id: 'open', name: 'Open', isRequired: true },
  pending: { id: 'pending', name: 'Pending', isRequired: false },
  hold: { id: 'hold', name: 'Hold', isRequired: false },
  solved: { id: 'solved', name: 'Solved', isRequired: false },
  closed: { id: 'closed', name: 'Closed', isRequired: true },
};

export const VELARIS_TICKET_PRIORITY = {
  urgent: { id: 'urgent', name: 'Urgent' },
  high: { id: 'high', name: 'High' },
  medium: { id: 'medium', name: 'Medium' },
  low: { id: 'low', name: 'Low' },
};

export const CONFIG_STATUS_LEVEL = {
  NOT_STARTED: 0, // not started
  IN_PROGRESS: 1, // started to edit
  COMPLETED: 2, // completed in UI
  SAVED: 3, // persisted in database
};

export const TICKET_STATUS_TEMPLATE = {
  mapping: { new: [], open: [], pending: [], hold: [], closed: [], solved: [] },
  status: CONFIG_STATUS_LEVEL.NOT_STARTED,
};

export const TICKET_PRIORITY_TEMPLATE = {
  mapping: { low: [], medium: [], high: [], urgent: [] },
  status: CONFIG_STATUS_LEVEL.NOT_STARTED,
};

export const SUPPORT_DEDUPLICATION_TEMPLATE = {
  status: CONFIG_STATUS_LEVEL.NOT_STARTED,
  velaris: '',
  vendor: '',
};
export const FIELD_MAPPING_TYPE = {
  DEDUPLICATION: 'deduplication',
  TICKET_STATUS: 'ticketStatus',
  TICKET_PRIORITY: 'ticketPriority',
};

export const VELARIS_TICKET_DEDUPLICATION_OPTIONS = [
  { name: 'externalId', displayName: 'External ID', dataType: 'string' },
  { name: 'ticketId', displayName: 'Ticket ID', dataType: 'string' },
];
